export default __webpack_public_path__ + "static/media/dieukhach.9ca54d87.png";